import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "cartDetails/fetch";
    ActionTypes["addProductFetch"] = "cartDetails/addProductFetch";
    ActionTypes["fetchSuccess"] = "cartDetails/fetchSuccess";
    ActionTypes["fetchError"] = "cartDetails/fetchError";
    ActionTypes["reset"] = "cartDetails/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    addProductFetch: createAction(ActionTypes.addProductFetch, (fetchStatus) => ({
        payload: fetchStatus
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (cartDetails) => ({
        payload: { cartDetails }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
